{
  "pageTitle": "Media Unit Catalog",
  "permissionDenied": "You don't have access to this section.",
  "table": {
    "columns": {
      "id": "ID",
      "supplierNumber": "Supplier no.",
      "format": "Format",
      "mediaType": "Media type",
      "noPhoto": "Photo",
      "city": "City",
      "address": "Address",
      "supplier": "Supplier",
      "region": "Region",
      "dimensions": "Dimensions",
      "area": "Area",
      "lighting": "Lighting",
      "catalogPrice": "List price",
      "agglomeration": "Agglomeration",
      "county": "County",
      "audienceEstimate": "Est. audience",
      "grwId": "GRW number",
      "material": "Material",
      "notes": "Notes",
      "locationDescription": "Location description",
      "wfContactPerson": "WF/mural contact person",
      "multiformat": "Multiformat",
      "tags": "Tags",
      "rent": "Rent",
      "exposureCost": "Exposure cost",
      "additionalCosts": "Additional costs",
      "discountedPrice": "Discounted price",
      "lastMinutePrice": "Last minute price",
      "starterPrice": "Starter price",
      "productionCost": "Production cost",
      "installationCost": "Installation cost",
      "dismantlingCost": "Dismantling cost",
      "clientProduction": "Production",
      "clientInstallation": "Installation",
      "clientDismantling": "Dismantling",
      "clientAdditionalFees": "Additional fees",
      "muralEcoProduction": "Eco-mural production",
      "roadNumber": "Road number"
    },
    "columnVisibility": {
      "toggleButton": "Columns",
      "sectionLabel": "Column visibility",
      "searchPlaceholder": "Search columns...",
      "noResults": "No column found"
    },
    "availability": "Availability",
    "noPhotoAria": "No photos",
    "hasPhotoAria": "Preview unit photos",
    "rowLinkAriaLabel": "Open media unit details {{id}}",
    "maskedExplanation": "You don't have permission to view this value."
  },
  "availability": {
    "loadMore": "Load more",
    "enquireAvailability": "Ask about availability",
    "enquireSubject": "Availability inquiry: {{unitLabel}}{{city}}",
    "setStatusManually": "Set status manually",
    "moreEntries": "+{{n}} more",
    "expandStackAriaLabel": "Expand full reservation list",
    "reserveSingle": "Reserve period: {{period}} for {{unitLabel}}?",
    "addOptionBtn": "Option",
    "reserveBtn": "Reserve",
    "cancelBtn": "Cancel",
    "closeBtn": "Close",
    "prevWindow": "Previous window",
    "nextWindow": "Next window",
    "occupiedByOther": "Reserved by another user",
    "unavailableWindowMessage": "Unavailable: {{period}}",
    "calendarReserve": {
      "statusReservation": "Reservation",
      "statusOption": "Option",
      "dayCount_one": "{{count}} day",
      "dayCount_few": "{{count}} days",
      "dayCount_many": "{{count}} days",
      "dayCount_other": "{{count}} days",
      "chooseOfferBtn": "Choose offer",
      "confirmBtn": "Confirm",
      "cancelBtn": "Cancel",
      "noOfferSelectedHint": "Select an offer to continue",
      "unitLabel": "Media unit: {{label}}"
    },
    "inspect": {
      "status": {
        "option": "Option",
        "soft": "Soft",
        "hard": "Confirmed reservation",
        "sold": "Sold",
        "blocked": "Blocked"
      },
      "holderLabel": "Holder",
      "clientLabel": "Client",
      "offerLabel": "Offer",
      "sourceLabel": "Source",
      "expiresLabel": "Expires"
    },
    "select": {
      "summaryPrefix": "Selected",
      "periodsCount_one": "{{count}} period",
      "periodsCount_few": "{{count}} periods",
      "periodsCount_many": "{{count}} periods",
      "periodsCount_other": "{{count}} periods",
      "unitsCount_one": "{{count}} media unit",
      "unitsCount_few": "{{count}} media units",
      "unitsCount_many": "{{count}} media units",
      "unitsCount_other": "{{count}} media units",
      "offerFieldLabel": "Offer",
      "clearBtn": "Clear",
      "reserveBtn": "Reserve",
      "optionBtn": "Option",
      "releaseBtn": "Release",
      "queueJoinDisabledHint": "A queue entry covers a single term only.",
      "confirmReleaseTitle": "Release reservations",
      "confirmReleaseSingleBody": "You will release the reservation from offer \"{{offerName}}\" on media unit {{mediaUnit}}, dates: {{dateRange}}.",
      "confirmReleaseUnknownOffer": "an unspecified offer",
      "confirmReleaseUnknownUnit": "this media unit",
      "confirmReleaseCancelBtn": "Cancel",
      "confirmReleaseSubmitBtn": "Release",
      "releaseModeChoice": {
        "title": "What would you like to release?",
        "wholeLabel": "The entire reservation period",
        "selectedLabel": "Only the selected days"
      },
      "confirmReleaseBreakdown": {
        "loading": "Working out what releasing would do…",
        "error": "We couldn't work out what releasing would do.",
        "retryBtn": "Try again",
        "empty": "There's nothing to release in this selection.",
        "releasableLabel": "Will be released",
        "queueExitLabel": "Will leave queue",
        "unresolvableLabel": "Can't be released",
        "unresolvableSoldReason": "The reservation has been sold — the media unit will be left unchanged.",
        "remainingRangeDetail": "Will remain reserved: {{range}}",
        "remainingRangesDetail": "Will remain reserved: {{rangeA}} and {{rangeB}}"
      },
      "releaseResultToast": "Released {{released}} reservations, left {{queuesLeft}} queues.",
      "releaseResultSelected": {
        "remainingRangeDetail": "Remains reserved: {{range}}",
        "remainingRangesDetail": "Remains reserved: {{rangeA}} and {{rangeB}}",
        "queuesLeftLabel": "Left {{count}} queues.",
        "reasonSold": "The reservation has been sold.",
        "reasonNotHeld": "You no longer hold this reservation.",
        "reasonNotFound": "This reservation no longer exists.",
        "reasonNotInSelectedRange": "This reservation's dates changed before the release could be processed.",
        "reasonGeneric": "This reservation could not be released."
      },
      "optionDialog": {
        "title": "Option visibility",
        "excludedSummary_one": "{{count}} held period will not be covered by the option — it is already held.",
        "excludedSummary_other": "{{count}} held periods will not be covered by the option — they are already held.",
        "modeDays": "Number of days",
        "modeDate": "Date",
        "confirmBtn": "Confirm",
        "cancelBtn": "Cancel"
      },
      "reserveDialog": {
        "title": "Confirm reservation",
        "dateRangeLabel": "Reservation date range",
        "dateLabel": "Expiry date",
        "datePlaceholder": "Pick a date",
        "autoHint": "Expiry dates differ across the selected units — we suggest the latest of the computed terms; you can change it using the calendar.",
        "description": "The system suggests an expiry date — you can change it using the calendar.",
        "splitSummary": "{{reservedCount}} will be reserved outright and {{queuedCount}} will be queued. The shared expiry date also covers the queued periods — if promoted after it has run out, they receive the standard queued term instead.",
        "confirmBtn": "Reserve",
        "cancelBtn": "Cancel"
      },
      "reserveResult": {
        "reservedLabel": "Reserved",
        "queuedLabel": "Queued",
        "failedLabel": "Failed",
        "expiresOn": "expires {{date}}",
        "dismissBtn": "Dismiss result"
      }
    }
  },
  "filters": {
    "region": "Region",
    "county": "County",
    "agglomeration": "Agglomeration",
    "city": "City",
    "location": "Location",
    "locationSearchPlaceholder": "Search region, county, agglomeration, city…",
    "locationInfoHint": "Selected areas are combined (OR) — add locations to broaden results. Other filters narrow the result.",
    "locationInfoHintLabel": "Location filter information",
    "administrativeArea": "District",
    "formatCode": "Format",
    "mediaType": "Media type",
    "supplierId": "Supplier",
    "supplierNumber": "Supplier no.",
    "grwId": "Internal no.",
    "lighting": "Lighting",
    "material": "Material",
    "multiformat": "Multiformat",
    "tags": "Tags",
    "address": "Address",
    "area": "Area",
    "width": "Width",
    "height": "Height",
    "audience": "Audience",
    "catalogPrice": "Catalog price",
    "rent": "Rent",
    "exposureCost": "Exposure cost",
    "additionalCosts": "Additional costs",
    "discountedPrice": "Discounted price",
    "lastMinutePrice": "Last minute price",
    "starterPrice": "Starter price",
    "productionCost": "Production cost",
    "installationCost": "Installation cost",
    "dismantlingCost": "Dismantling cost",
    "clientProduction": "Production",
    "clientInstallation": "Installation",
    "clientDismantling": "Dismantling",
    "clientAdditionalFees": "Additional fees",
    "notes": "Notes",
    "roadNumber": "Road number",
    "rangeMinLabel": "Min",
    "rangeMaxLabel": "Max",
    "noPhoto": "No photo",
    "availability": "Availability",
    "importJobChip": "Import #{{id}}",
    "status": "Status",
    "toggleLabel": "Filters",
    "searchPlaceholder": "Search...",
    "searchBox": {
      "placeholder": "Search by number, address, city...",
      "ariaLabel": "Search media units",
      "openOnMap": "Open on map"
    },
    "exclude": {
      "include": "Include",
      "exclude": "Exclude",
      "toggleAria": "Toggle exclude mode for filter {{field}}"
    },
    "allLabel": "All",
    "cancelLabel": "Cancel",
    "applyLabel": "Apply",
    "selectedCountLabel": "{{n}} selected",
    "clearLabel": "Clear",
    "clearAllLabel": "Clear all",
    "showLessLabel": "Less",
    "addFilterLabel": "Add filter",
    "removeAriaLabel": "Remove filter {{label}}"
  },
  "toolbar": {
    "addButton": "Add media unit",
    "mapButton": "Map",
    "importMenuButton": "Import…",
    "importMediaButton": "Update media units",
    "importAvailabilityButton": "Update availability"
  },
  "quickAdd": {
    "addAllFiltered": "Add all to offer",
    "rowActionLabel": "Add to offer",
    "rowActionAriaLabel": "Add {{id}} to offer",
    "bulkActionLabel": "Add selected to offer",
    "toolbarAriaLabel": "Bulk quick-add-to-offer actions",
    "selectedCountSuffix": "selected",
    "visibleCountSuffix": "visible",
    "moreActionsLabel": "More actions",
    "clearSelectionLabel": "Clear selection",
    "limitExceeded": "Select at most 100 media units.",
    "subtitle_one": "Adding {{count}} media unit",
    "subtitle_few": "Adding {{count}} media units",
    "subtitle_many": "Adding {{count}} media units",
    "subtitle_other": "Adding {{count}} media units",
    "confirmExistingWithCount_one": "Add {{count}} media unit",
    "confirmExistingWithCount_few": "Add {{count}} media units",
    "confirmExistingWithCount_many": "Add {{count}} media units",
    "confirmExistingWithCount_other": "Add {{count}} media units",
    "confirmNewWithCount_one": "Create and add {{count}} media unit",
    "confirmNewWithCount_few": "Create and add {{count}} media units",
    "confirmNewWithCount_many": "Create and add {{count}} media units",
    "confirmNewWithCount_other": "Create and add {{count}} media units",
    "selection": {
      "selectAllAriaLabel": "Select all media units",
      "selectRowAriaLabel": "Select {{id}} {{city}}"
    },
    "picker": {
      "title": "Add to offer",
      "subtitle": "Select the target offer",
      "draftUnitLabel": "media units",
      "draftSummarySeparator": "•",
      "pendingUnitsLabel": "Adding",
      "targetOfferLabel": "Target offer",
      "searchPlaceholder": "Search offer",
      "createNewLinkLabel": "Add new",
      "changeSelectionLabel": "Change",
      "pickOfferLabel": "Select the target offer",
      "cancelChangeLabel": "Cancel change",
      "backToExistingLabel": "Back to existing",
      "lastUsedHintLabel": "The last used offer is selected by default.",
      "destinationLabel": "Adding to",
      "creationStatusHintLabel": "A new offer will be created on save.",
      "noPreselectionLabel": "No offer selected yet.",
      "noDraftsLabel": "No draft offers.",
      "noResultsLabel": "No offer matches your search.",
      "noPermissionLabel": "You don't have permission to edit offers.",
      "createNewLabel": "New offer",
      "createNewHint": "Create a new draft offer.",
      "clientFieldLabel": "Client",
      "clientFieldPlaceholder": "Select client",
      "salespersonFieldLabel": "Salesperson",
      "salespersonFieldPlaceholder": "Select salesperson",
      "salespersonFieldLockedHint": "You don't have permission to assign this offer to another salesperson.",
      "campaignDurationLabel": "Campaign duration",
      "campaignDurationPlaceholder": "Select date range",
      "campaignDurationInvalidRangeLabel": "End date must be on or after the start date",
      "confirmExistingLabel": "Add",
      "confirmNewLabel": "Create and add",
      "cancelLabel": "Cancel",
      "openFullFormLabel": "Open full form",
      "openFullFormHint": "Further configuration in the full form.",
      "validationClientRequiredLabel": "Select a client"
    }
  },
  "footer": {
    "shown": "Shown",
    "of": "of",
    "units": "media units"
  },
  "emptyState": "No media units to display",
  "emptyStateImportJob": "This import contains no matching media units",
  "emptyStatePermissionScope": "No media units to display — a permission scope may be limiting what you can see",
  "errorState": "Failed to load media units",
  "campaign": {
    "saveToButton": "Save to campaign",
    "savedToast": "Filters saved to campaign",
    "saveDialogTitle": "Save filters to campaign",
    "saveDialogDescription": "Filters will be restored the next time you open the campaign."
  },
  "detail": {
    "tags": {
      "sectionTitle": "Tags",
      "empty": "No tags",
      "clientVisibleMarker": "C"
    },
    "pageTitle": "Media Unit {{displayNumber}}",
    "backLink": "Media Unit Catalog",
    "backToMap": "Back to map",
    "clientDetail": {
      "backToOffer": "Back to offer",
      "notFound": "Media unit not found"
    },
    "editButton": "Edit",
    "deleteButton": "Delete unit",
    "deleteConfirm": "Are you sure you want to delete media unit {{grwId}}?",
    "deleteSuccess": "Media unit deleted",
    "deleteError": "Failed to delete media unit",
    "deleteBlockedByDraftOffer": "Cannot delete: this media unit is used in a draft offer. Remove it from the draft first.",
    "deleteDialogTitle": "Delete media unit",
    "deleteDialogCancel": "Cancel",
    "deleteDialogConfirm": "Delete",
    "perMonth": "PLN / month",
    "noPhotos": "No photos",
    "downloadPhoto": "Download photo",
    "downloadAllPhotos": "Download all photos",
    "openLightbox": "Enlarge photo",
    "lightbox": {
      "close": "Close",
      "previous": "Previous photo",
      "next": "Next photo",
      "counter": "{{current}} / {{total}}"
    },
    "availabilityCalendar": "Availability calendar",
    "availabilityLastUpdatedHintLabel": "When availability was last updated",
    "availabilityLastUpdatedHint": "Availability last updated: {{date}}",
    "noNotes": "No notes",
    "bundle": {
      "title": "Bundle",
      "description": "This media unit is part of a bundle (two sides of the same structure)."
    },
    "sections": {
      "identification": "Identification",
      "location": "Location",
      "specs": "Technical specification",
      "costs": "Costs",
      "notes": "Notes",
      "supplier": "Supplier",
      "additionalServices": "Additional services"
    },
    "calendar": {
      "reserved": "Reserved",
      "available": "Available",
      "prevMonth": "Previous month",
      "nextMonth": "Next month"
    },
    "openInGoogleMaps": "Open in Google Maps",
    "techSpec": {
      "title": "Technical specifications",
      "emptyState": "No attached specifications",
      "uploadZoneHint": "Drag a file or click to select",
      "uploadZoneFormats": ".doc, .docx, .xls, .pdf - max 20 MB",
      "uploadButton": "Add specification",
      "uploading": "Uploading file...",
      "errorType": "File type not allowed",
      "errorTypeHint": "Allowed formats: .doc, .docx, .xls, .pdf",
      "errorSize": "File is too large",
      "errorSizeHint": "Maximum file size: 20 MB",
      "dragOver": "Drop file here",
      "deleteConfirmTitle": "Delete file?",
      "deleteConfirmDescription": "Are you sure you want to delete this file? This action cannot be undone.",
      "deleteConfirmCancel": "Cancel",
      "deleteConfirmConfirm": "Delete",
      "deleteError": "Failed to delete file. Try again."
    },
    "fields": {
      "supplierNumber": "Supplier no.",
      "supplier": "Supplier",
      "format": "Format",
      "mediaType": "Media type",
      "status": "Status",
      "address": "Address",
      "region": "Region",
      "county": "County",
      "agglomeration": "Agglomeration",
      "city": "City",
      "gpsCoordinates": "GPS coordinates",
      "locationDescription": "Location description",
      "dimensions": "Dimensions",
      "area": "Area",
      "material": "Material",
      "lighting": "Lighting",
      "catalogPrice": "List price",
      "rent": "Rent",
      "exposureCost": "Exposure cost",
      "installCost": "Installation cost",
      "dismantlingCost": "Dismantling cost",
      "productionCost": "Production cost",
      "additionalCosts": "Additional cost",
      "starterPrice": "Catalog price",
      "discountedPrice": "Discounted price",
      "clientProduction": "Production",
      "muralEcoProduction": "Eco-mural production",
      "clientInstallation": "Installation",
      "clientDismantling": "Dismantling",
      "clientAdditionalFees": "Additional fees",
      "priceSum": "Total"
    },
    "costs": {
      "toggleAria": "Collapse/expand costs section"
    },
    "availability": {
      "toggleAria": "Collapse/expand availability calendar"
    }
  },
  "form": {
    "add": {
      "title": "New media unit",
      "pageTitle": "Add media unit",
      "subtitle": "Fill in media unit data.",
      "requiredHint": "Fields marked with * are required."
    },
    "saveErrorMessage": "Failed to save changes. Check the data and try again.",
    "saveError": "An error occurred while saving",
    "supplierNumberCollision": "This supplier number is already assigned to another media unit of this supplier.",
    "loadingPlaceholder": "Loading...",
    "edit": {
      "title": "Edit media unit",
      "pageTitle": "Edit media unit {{displayNumber}}",
      "backLink": "Media unit details",
      "unsavedBadge": "Unsaved changes",
      "subtitleText": "Editing media unit {{displayNumber}}.",
      "requiredHint": "Fields marked with * are required.",
      "successTitle": "Changes saved",
      "successDescription": "Media unit {{displayNumber}} has been updated. Cost change history is preserved.",
      "discardTitle": "You have unsaved changes",
      "discardMessage": "Are you sure you want to discard your changes? This action cannot be undone.",
      "discardConfirm": "Discard changes",
      "discardCancel": "Continue editing"
    },
    "successAdd": {
      "title": "Media unit added successfully",
      "description": "The new media unit is now visible in the media unit catalog.",
      "addAnother": "Add another media unit",
      "goToCatalog": "Go to catalog"
    },
    "sections": {
      "photos": "Photos",
      "photosSubtitle": "Add media unit photos.",
      "photosEditSubtitle": "Manage media unit photos. Existing photos can be removed and new ones added.",
      "supplier": "Supplier data",
      "technical": "Technical specification",
      "location": "Location",
      "costs": "Costs",
      "costsSubtitle": "Costs are permanently saved when adding a media unit. Change history is preserved.",
      "costsEditSubtitle": "Cost changes are recorded in history. Previous values are preserved.",
      "prices": "Prices",
      "notes": "Notes"
    },
    "fields": {
      "supplierNumber": "Supplier no.",
      "supplier": "Supplier",
      "format": "Format",
      "material": "Material",
      "lighting": "Lighting",
      "width": "Width (m)",
      "height": "Height (m)",
      "area": "Area (m²)",
      "region": "Region",
      "county": "County",
      "agglomeration": "Agglomeration",
      "city": "City",
      "address": "Address",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "catalogPrice": "List price (PLN)",
      "rent": "Rent (PLN)",
      "productionCost": "Production cost (PLN)",
      "installCost": "Installation cost (PLN)",
      "dismantlingCost": "Dismantling cost (PLN)",
      "exposureCost": "Exposure cost (PLN)",
      "additionalCosts": "Additional cost (PLN)",
      "discountedPrice": "Discounted price (PLN)",
      "lastMinutePrice": "Last minute price (PLN)",
      "starterPrice": "Starter price (PLN)",
      "clientProduction": "Production (PLN)",
      "clientInstallation": "Installation (PLN)",
      "clientDismantling": "Dismantling (PLN)",
      "clientAdditionalFees": "Additional fees (PLN)",
      "notes": "Notes",
      "wfContactPerson": "WF/mural contact person",
      "locationDescription": "Location description",
      "rentDisabledHint": "You don't have permission to edit rent.",
      "costsDisabledHint": "You don't have permission to edit costs.",
      "supplierDisabledHint": "You don't have permission to edit supplier details."
    },
    "placeholders": {
      "supplierNumber": "e.g. AMS-WAW-044",
      "supplier": "Select supplier...",
      "format": "Select format...",
      "material": "Select material...",
      "lighting": "Select lighting...",
      "clearSelection": "— none —",
      "region": "Select region...",
      "county": "Select county...",
      "countyNoRegion": "Select region first",
      "agglomeration": "e.g. Warszawska",
      "city": "e.g. Warsaw",
      "address": "e.g. Marszalkowska 12, toward city center",
      "latitude": "e.g. 52.2297",
      "longitude": "e.g. 21.0122",
      "width": "e.g. 6",
      "height": "e.g. 3",
      "area": "Auto",
      "catalogPrice": "e.g. 4500",
      "rent": "e.g. 3200",
      "productionCost": "e.g. 450",
      "installCost": "e.g. 350",
      "dismantlingCost": "e.g. 200",
      "exposureCost": "e.g. 4500",
      "additionalCosts": "e.g. 100",
      "discountedPrice": "e.g. 4000",
      "lastMinutePrice": "e.g. 3500",
      "starterPrice": "e.g. 3000",
      "clientProduction": "e.g. 500",
      "clientInstallation": "e.g. 400",
      "clientDismantling": "e.g. 250",
      "clientAdditionalFees": "e.g. 150",
      "notes": "Additional information about the media unit...",
      "wfContactPerson": "Full name of the WF/mural contact person...",
      "locationDescription": "Descriptive location text for the media unit, e.g. corner of..."
    },
    "validation": {
      "supplierNumberRequired": "Supplier number is required",
      "supplierRequired": "Supplier is required",
      "formatRequired": "Format is required",
      "regionRequired": "Region is required",
      "cityRequired": "City is required",
      "addressRequired": "Address is required",
      "widthRequired": "Width is required",
      "widthPositive": "Width must be greater than 0",
      "heightRequired": "Height is required",
      "heightPositive": "Height must be greater than 0",
      "nonNegative": "Value cannot be negative",
      "mustBeValidSelection": "Select a valid value",
      "invalidCoordinate": "Enter a valid coordinate (e.g. 52.2297 or 50°54'05.8\"N)",
      "requiredFieldsMissing": "Fill in the required fields to save changes."
    },
    "photos": {
      "dropzone": "Drag photos or click to select",
      "dropzoneEdit": "Drag photos or click",
      "hint": "JPG, PNG up to 10 MB. Max 10 photos.",
      "hintEdit": "JPG, PNG, WebP up to 10 MB. Max 10 photos.",
      "selectFiles": "Select files",
      "tooMany": "You can add up to 10 photos",
      "tooManyDetailed": "Skipped {{count}} photos (10-photo limit exceeded): {{names}}.",
      "wrongType": "Only JPG, PNG, or WebP files are allowed",
      "wrongTypeDetailed": "{{count}} files not added (unsupported format): {{names}}. Supported formats: JPG, PNG, WebP.",
      "loading": "Loading data...",
      "removeAriaLabel": "Remove {{name}}"
    },
    "costHistory": {
      "title": "Cost change history",
      "noHistory": "No cost change history",
      "field": "Field",
      "previousValue": "Previous value",
      "newValue": "New value",
      "date": "Date",
      "catalogPrice": "List price",
      "rent": "Rent",
      "printCost": "Print cost",
      "installCost": "Installation cost",
      "dismantlingCost": "Dismantling cost",
      "productionCost": "Production cost"
    },
    "tags": {
      "sectionTitle": "Tags",
      "placeholder": "Select tags...",
      "searchPlaceholder": "Search tags...",
      "noResults": "No results",
      "removeAriaLabel": "Remove tag {{label}}",
      "inactiveHint": "(inactive)"
    },
    "saveButton": {
      "idle": "Save media unit",
      "saving": "Saving...",
      "saved": "Saved!",
      "error": "Save error",
      "saveChanges": "Save changes"
    }
  },
  "bulkEdit": {
    "action": "Bulk edit",
    "drawerTitle": "Bulk edit",
    "fieldLabel": "Field to edit",
    "valueLabel": "New value",
    "confirmTitle": "Confirm bulk edit",
    "confirmMessage": "{{count}} media units will be updated.",
    "hiddenCount": "{{count}} outside the current results.",
    "submit": "Update",
    "cancel": "Cancel",
    "successToast": "{{updated}} updated, {{failed}} errors",
    "failedToast": "Bulk edit failed",
    "selectAll": "Select all {{count}} matching",
    "capWarning": "Bulk edit is limited to 500 media units. Reduce the selection or apply a more precise filter.",
    "toolbarAriaLabel": "Bulk media unit edit actions",
    "selectedCountSuffix": "selected",
    "moreActionsLabel": "More actions",
    "clearSelectionLabel": "Clear selection",
    "nextBtn": "Next",
    "backBtn": "Back",
    "selectPlaceholder": "Select value...",
    "fields": {
      "mediaType": "Media type",
      "city": "City",
      "lifecycleStatus": "Lifecycle status",
      "supplier": "Supplier"
    },
    "lifecycleStatus": {
      "active": "Active",
      "inactive": "Inactive",
      "archived": "Archived"
    },
    "errors": {
      "generic": "Failed to save the bulk edit. Try again."
    }
  },
  "bulkMarkAvailability": {
    "action": "Block availability",
    "drawerTitle": "Bulk block availability",
    "presetFirstHalf": "1-15",
    "presetSecondHalf": "16-end of month",
    "dateRangeLabel": "Availability period",
    "dateRangePlaceholder": "Select date range…",
    "stateLabel": "State",
    "statePlaceholder": "Select state...",
    "state": {
      "FREE": "Free",
      "UNAVAILABLE": "Unavailable"
    },
    "confirmMessage": "{{count}} media units will be updated.",
    "hiddenCount": "{{count}} outside the current results.",
    "submit": "Block",
    "cancel": "Cancel",
    "resultToast": "{{updated}} updated, {{failed}} errors",
    "capWarning": "Bulk action is limited to 500 media units. Reduce the selection or apply a more precise filter."
  },
  "bulkRecomputeLocation": {
    "action": "Recompute location",
    "dialogTitle": "Recompute location",
    "confirmMessage": "This will recompute region, county, and agglomeration from coordinates for {{count}} media units.",
    "hiddenCount": "{{count}} outside the current results.",
    "submit": "Recompute",
    "cancel": "Cancel",
    "resultToast": "{{updated}} updated, {{failed}} errors",
    "capWarning": "Bulk action is limited to 500 media units. Reduce the selection or apply a more precise filter."
  },
  "bulkDelete": {
    "action": "Delete selected",
    "dialogTitle": "Delete selected media units",
    "confirmMessage": "This will delete {{count}} media units. They will go to the trash and can be restored within 3 days.",
    "hiddenCount": "{{count}} outside the current results.",
    "submit": "Delete",
    "cancel": "Cancel",
    "resultToast": "{{deleted}} deleted, {{failed}} skipped",
    "capWarning": "Bulk action is limited to 500 media units. Reduce the selection or apply a more precise filter."
  },
  "offerContext": {
    "bar": {
      "message": "Adding to offer: {{offerName}}",
      "returnLabel": "Return to offer",
      "exitAriaLabel": "Stop adding to offer"
    }
  },
  "tags": {
    "pageTitle": "System dictionaries - Tags",
    "pageSubtitle": "Manage advertising media tags",
    "permissionDenied": "No access to this section.",
    "actions": {
      "addTag": "Add tag",
      "edit": "Edit",
      "deactivate": "Deactivate",
      "deletePermanent": "Delete permanently"
    },
    "deletePermanent": {
      "title": "Permanently delete tag \"{{name}}\"?",
      "description": "The tag will be permanently deleted and removed from all media units that had it. This action cannot be undone.",
      "affectedUnits_one": "The tag is assigned to {{count}} media unit — it will be removed from it.",
      "affectedUnits_few": "The tag is assigned to {{count}} media units — it will be removed from them.",
      "affectedUnits_many": "The tag is assigned to {{count}} media units — it will be removed from them.",
      "affectedUnits_other": "The tag is assigned to {{count}} media units — it will be removed from them.",
      "confirm": "Delete permanently",
      "cancel": "Cancel"
    },
    "filters": {
      "searchPlaceholder": "Search by code or label...",
      "statusAll": "All",
      "statusActive": "Active",
      "statusInactive": "Inactive"
    },
    "table": {
      "code": "Code",
      "label": "Label",
      "clientVisible": "Visible to client",
      "clientVisibleYes": "Yes",
      "clientVisibleNo": "No",
      "sortOrder": "Order",
      "status": "Status"
    },
    "empty": {
      "title": "No tags",
      "description": "Add your first tag to get started."
    },
    "dialog": {
      "createTitle": "New tag",
      "editTitle": "Edit tag",
      "close": "Close",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving...",
      "fields": {
        "code": "Code",
        "codePlaceholder": "e.g. no_alcohol",
        "codeHint": "Stable import key – lowercase, no spaces.",
        "label": "Label",
        "labelPlaceholder": "Display name",
        "sortOrder": "Order",
        "isClientVisible": "Visible to client",
        "isActive": "Active"
      }
    },
    "errors": {
      "codeTaken": "A tag with this code already exists."
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "pagination": {
      "page": "Page {{page}} of {{total}} ({{count}} results)",
      "prev": "Previous page",
      "next": "Next page",
      "goToPage": "Page {{page}}"
    }
  },
  "bulkDownload": {
    "dialog": {
      "title": "Download technical specifications",
      "fileCount_one": "{{count}} file",
      "fileCount_few": "{{count}} files",
      "fileCount_many": "{{count}} files",
      "fileCount_other": "{{count}} files",
      "totalSize": "Total size: {{size}}",
      "largeSizeWarning": "The download may take longer due to the archive size.",
      "skippedUnitsWarning": "{{skipped}} of {{total}} units have no attached specifications and will be skipped.",
      "confirmBtn": "Download",
      "cancelBtn": "Cancel"
    },
    "trigger": {
      "label": "Download specifications",
      "disabledEmpty": "Select units to download",
      "disabledCap": "You can download up to 200 units at a time"
    },
    "toast": {
      "skippedFiles": "Skipped {{count}} files: {{files}}",
      "manifestError": "Failed to fetch the file list",
      "streamError": "Error during file download"
    }
  },
  "supplierPhotoZip": {
    "trigger": {
      "label": "Download supplier photos"
    },
    "bulkTrigger": {
      "label": "Download photos of selected units",
      "disabledEmpty": "Select units to download",
      "disabledCap": "You can download up to 200 units at a time"
    },
    "toast": {
      "skippedFiles": "Skipped {{count}} photos: {{files}}",
      "manifestError": "Failed to fetch the photo list",
      "streamError": "Error during photo download"
    }
  },
  "trash": {
    "pageTitle": "Media units trash",
    "link": "Trash",
    "emptyState": "No deleted media units",
    "table": {
      "columns": {
        "grwId": "GRW ID",
        "city": "City",
        "deletedAt": "Deleted at",
        "expiresAt": "Expires"
      }
    },
    "countdown": {
      "remaining": "{{days}}d {{hours}}h remaining",
      "today": "Expires today",
      "expired": "Expired"
    },
    "actions": {
      "restore": "Restore"
    },
    "restore": {
      "success": "Media unit restored",
      "error": "Error restoring media unit"
    },
    "referencedByOffers_one": "Referenced in {{count}} offer — won't be purged automatically",
    "referencedByOffers_few": "Referenced in {{count}} offers — won't be purged automatically",
    "referencedByOffers_many": "Referenced in {{count}} offers — won't be purged automatically",
    "referencedByOffers_other": "Referenced in {{count}} offers — won't be purged automatically"
  }
}
